import { Box, Fab, Popover } from "@mui/material";
import IconHelp from "../componentsStyled/icon/Iconhelp";
import { useState } from "react";

export default function ChatFlutuant() {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(undefined);

  const handleClick = (event) => {
    setIsOpen(!isOpen);
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box position={"fixed"} bottom={20} right={20}>
      <Fab onClick={handleClick} sx={{ borderRadius: 3, bgcolor: "#F3F3F3" }}>
        <IconHelp width={30} />
      </Fab>
      <Popover
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClick}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}>
        <div style={{ padding: 20 }}>
          Dúvidas de como funciona? Acesse nossa&nbsp;
          <a href="https://www.kappa.com.br/portal-de-ajuda" target="_blank">
            Central de ajuda
          </a>
        </div>
      </Popover>
    </Box>
  );
}
